import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DirectLendingComponent } from './direct-lending/direct-lending.component';
import { CelcomdigiComponent } from './components/celcomdigi/celcomdigi.component';
import { CelcomdigiDetailsComponent } from './components/celcomdigi-details/celcomdigi-details.component';

const routes: Routes = [
  {
		path: "main",
		component: DirectLendingComponent,
	},
  {
    path: "celcomdigi",
    component: CelcomdigiComponent
  },
  {
    path: "celcomdigi/details",
    component: CelcomdigiDetailsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DirectLendingRoutingModule { }
